"use strict";

exports.__esModule = true;
exports.GRAY_DARK = exports.WHITE = exports.GREEN = exports.BLUE = exports.RED = void 0;
var RED = '#f44';
exports.RED = RED;
var BLUE = '#1989fa';
exports.BLUE = BLUE;
var GREEN = '#07c160';
exports.GREEN = GREEN;
var WHITE = '#fff';
exports.WHITE = WHITE;
var GRAY_DARK = '#969799';
exports.GRAY_DARK = GRAY_DARK;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/lib/utils/color.js
// module id = xi9C
// module chunks = 0